module.exports = __webpack_public_path__ + "static/media/Logo-HSBC.2b862719.svg";